import {
  addNewInstance,
  getEntityInstances,
} from "../../../repositories/portal_api/ConectaZap";
import { notify } from "../../../utils/notify";

export const getInstances = async (document) => {
  try {
    const response = await getEntityInstances(document);

    if (response?.success) {
      let instances = [];

      if (response?.data?.data?.length > 0) {
        response?.data?.data.forEach((instance) => {
          let status = "waiting";

          if (instance?.status === 0 && instance?.phoneNumber) {
            status = "disconnected";
          } else if (instance.status === 1) {
            status = "connected";
          }

          instances.push({
            id: instance.id,
            name: instance.instanceName,
            status: status,
            number: instance.phoneNumber,
            flags: instance.flags,
            phoneNumber: instance?.phoneNumber,
            phoneNumberId: instance?.phoneNumberId,
          });
        });
      }
      return instances;
    } else {
      throw new Error("Erro ao buscar instâncias");
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const addInstance = async (document) => {
  try {
    const response = await addNewInstance(document);

    if (response.success) {
      notify("Instância adicionada com sucesso", true, "success");
      const instances = await getInstances();

      return instances;
    } else {
      if (response.code === 403) {
        notify("Limite de contas atingido", true, "warning");
      } else {
        throw new Error("Erro ao adicionar conta", true, "error");
      }
    }
  } catch (error) {
    console.log(error);
    notify("Erro ao adicionar conta", true, "error");
  }
};
